import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import BookingService from "app/services/booking/booking.service";
import BookingsConflicts from "app/services/bookingsConflicts/index";
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';
import { bookingActions } from 'app/reducers/booking/slice';
import store from 'appRoot/Store';

const NS = 'BookingsErrorsCtrl';

export default function BookingsErrorsCtrl(
  $rootScope, $scope, $filter
) {
  "ngInject";

  const vm = this;
  //-- define public properties
  vm.loading = false;
  const timeZoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate.setMonth(vm.endDate.getMonth() + 1);
  vm.loadError = false;
  vm.hideDays = true;
  // define public medthods
  vm.getErrors = getErrors;

  function getErrors() {
    if (!vm.loading) {
      vm.loading = true;
      vm.loadError = false;
      var affectedBookings;
      var overlapConflicts;
      BookingsAffectedService.checkDateRange(vm.startDate, vm.endDate).then(function (affectedBookingsResults) {
        affectedBookings = affectedBookingsResults;
        return BookingService.getBetweenDates(vm.startDate, vm.endDate);
      }).then(function (bookings) {
        return BookingsConflicts.checkBookingsForConflicts(bookings);
      }).then(function (conflictResults) {
        overlapConflicts = conflictResults;
        store.dispatch(bookingActions.setOverlapConflicts(overlapConflicts));
        parseErrors(affectedBookings, overlapConflicts);
      }).catch(function () {
        vm.loading = false;
        vm.loadError = true;
      });
    }
  }

  function parseErrors(affectedBookings, overlapConflicts) {
    vm.timeConflicts = $filter('filter')(affectedBookings, {
      timeEffected: true
    });
    vm.tableConflicts = $filter('filter')(affectedBookings, {
      timeEffected: false
    });
    vm.overlapConflicts = overlapConflicts;
    vm.loading = false;
  }
}
